import api from '@/lib/api/axios'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'

export interface UpdateRunBookItem {
    id: number | null
    requestID: string | null
    objectID: string | null
    objectDescription: string | null
    objectversionsID: number | null
    scenario: number | null
    versionMetadata: string | null
    versionAnalytics: number | null
    requestDateTime: string | Date | null
    location: string | null
    teamName: string | null
    responsibleTeamId: number | null
    forecastStartTime: string | Date | null
    forecastFinishTime: string | Date | null
    objectReady: number | null
    requestObjectCount: number
    noTasks: number | null
    noStarted: number | null
    noCompleted: number | null
    noIssues: number | null
    timeRemaining: number | null
    percentageComplete: number | null
    iconFilename: string | null
}

export interface UpdateRunBookStats {
    uniqueRequestCount: number
    objectCount: number
    locationCount: number
    runbookTaskCount?: number
    runbookTaskStarted?: number
    runbookTaskCompleted?: number
    runbookTaskIssues?: number
}

export const updateRunbookApi = {
    list: (params?: ListParams & { location?: string; team?: string }) => {
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<UpdateRunBookItem>>('/api/update-runbook', { params: queryParams })
    },
    getLocationOptions: () => api.get<{ success: boolean; data: string[] }>('/api/update-runbook/filter-options/locations'),
    getTeamOptions: () => api.get<{ success: boolean; data: string[] }>('/api/update-runbook/filter-options/teams'),
    getStats: () => api.get<{ success: boolean; data: UpdateRunBookStats }>('/api/update-runbook/stats'),
}
